import { Link, useLocation } from '@/util/react-router-dom';
import styles from './menu.module.css';
import clsx from 'clsx';
import { LogoutButton } from '../logout-button';
import { TranslationKey } from '@/contexts/translations';
import { useTranslation } from '@/contexts/i18n-context';

export type MenuItem =
  | { type: 'link'; to: string; label: TranslationKey; isExternal?: boolean }
  | { type: 'logout-button' };

interface MenuProps {
  items: MenuItem[];
  isOpen: boolean;
  onItemClick: () => void;
}

export function Menu({ items, isOpen, onItemClick }: MenuProps) {
  const { t } = useTranslation();
  const location = useLocation();
  const isActive = (to: string) => location.pathname === to;

  return (
    <menu className={clsx(styles.menu, isOpen && styles.open)}>
      {items.map((item) =>
        item.type === 'link' ? (
          <li key={item.to}>
            <Link
              to={item.to}
              className={clsx('body-2', styles.menuItem, isActive(item.to) && styles.active)}
              onClick={onItemClick}
              {...(item.isExternal && { target: '_blank', rel: 'noopener noreferrer' })}
            >
              {t(item.label)}
            </Link>
          </li>
        ) : (
          <li key="logout-button">
            <div className={styles.divider} />
            <LogoutButton
              className={clsx(styles.logoutButton, 'body-2', styles.menuItem)}
              onClick={onItemClick}
              variant="none"
              fullWidth
            />
          </li>
        ),
      )}
    </menu>
  );
}
